import type { IconDefinition } from '@fortawesome/pro-regular-svg-icons'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'
import {
  optionItemElementLabel,
  optionItemElementLabelMain,
  optionItemElementSublabel
} from '~/components/Form/Input/Dropdown.css'
import type { AddressBookType } from '~/domains/actions/types'
import {
  ApplicantIcon,
  ContactIcon,
  ExternalRecipientIcon,
  UserIcon
} from '~/utils/icons'
import {
  optionDelete,
  optionIcon,
  optionInvalidNotice,
  optionRow
} from './AddressBookOption.css'

const ADDRESS_BOOK_ICON: Record<AddressBookType, IconDefinition> = {
  applicant: ApplicantIcon,
  contact: ContactIcon,
  user: UserIcon,
  external: ExternalRecipientIcon
}

type AddressBookOptionProps = {
  type: AddressBookType
  name: string
  email: string
  /** When set, renders a button to remove the saved external recipient from the address book. */
  onDelete?: () => void
  /** Warning displayed under the name (e.g. the typed email is invalid). */
  invalidNotice?: string
}

export const AddressBookOption = ({
  type,
  name,
  email,
  onDelete,
  invalidNotice
}: AddressBookOptionProps): ReactElement => (
  <div className={optionRow}>
    <span className={optionIcon}>
      <FontAwesomeIcon icon={ADDRESS_BOOK_ICON[type]} />
    </span>
    <div className={optionItemElementLabel}>
      <div className={optionItemElementLabelMain}>{name}</div>
      {email !== '' && name !== email && (
        <div className={optionItemElementSublabel}>{email}</div>
      )}
      {invalidNotice && (
        <div className={optionInvalidNotice}>{invalidNotice}</div>
      )}
    </div>
    {onDelete && (
      <button
        type="button"
        className={optionDelete}
        title="Oublier"
        aria-label="Oublier"
        onClick={(e) => {
          e.stopPropagation()
          onDelete()
        }}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    )}
  </div>
)
